import { render, staticRenderFns } from "./checkTranInLabels.vue?vue&type=template&id=2098f520&scoped=true&"
import script from "./checkTranInLabels.vue?vue&type=script&lang=js&"
export * from "./checkTranInLabels.vue?vue&type=script&lang=js&"
import style0 from "./checkTranInLabels.vue?vue&type=style&index=0&id=2098f520&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2098f520",
  null
  
)

component.options.__file = "checkTranInLabels.vue"
export default component.exports